<template>
    <div class="footer">
        <b-navbar toggleable="lg" type="light" variant="light" class="header-front">
            <div class="container d-flex flex-col gap-4" style="padding-top: 20px;padding-bottom: 20px;">
                <div class="d-flex gap-4 jusify-center">
                    <a href="https://alumni.fbeubaya.id/">
                        <img src="@/assets/images/logo-ika.png" alt="" class="logo-front" style="width: 100px;height: 100px;">
                    </a>
                    <a href="https://fbeubaya.id/">
                        <img src="@/assets/images/fbe-logo.svg" alt="" class="logo-front" style="width: 100px;height: 100px;">
                    </a>
                    <a href="https://www.ubaya.ac.id/">
                        <img src="@/assets/images/logo-ubaya.png" alt="" class="logo-front" style="height: 100px;">
                    </a>
                </div>
                <p>Copyright © 2025 Ikatan Alumni FBE UBAYA</p>
            </div>
        </b-navbar>
    </div>
</template>
<script>
    import { Icon } from '@iconify/vue2'

    export default {
        name: 'FooterFrontend',
        components: {
            Icon
        },
        data () {
            return {
                token: localStorage.getItem('token'),
                active_header: ''
            }
        },
        created () {
            if (this.$route.matched[0]) {
                this.get_active_header()
            }
        },
        watch: {
            $route: 'get_active_header'
        },
        methods: {
            activate: function (el) {
                this.active_header = el
            },
            get_active_header () {
                this.active_header = this.$route.matched[0].path
            }
        }
    }
</script>
